
<template>
  <div class="advertisement">
    <div class="advertisement-main">
      <module-title title="">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-plus"
            @click="opAddOrEdit('add')"
          >
            新增
          </el-button>
        </div>
      </module-title>
      <div>
        <el-table
          v-loading="searchForm.listLoading"
          :data="alldata"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="投放学段" prop="stageNames" align="center" />
          <el-table-column label="广告" prop="content" align="center" width="300px">
            <template slot-scope="scope" align="left">
              <img :src="scope.row.photoPath" alt width="65">
            </template>
          </el-table-column>
          <!-- v17.1 -->
          <el-table-column label="链接类型" align="center">
            <template slot-scope="scope">
              {{ scope.row.linkType===1?'H5':'应用' }}
            </template>
          </el-table-column>
          <el-table-column label="链接地址" align="center" prop="linkPath" />
          <el-table-column label="尺寸" align="center">
            <template slot-scope="scope" align="left">
              {{ scope.row.wide }}* {{ scope.row.high }}
            </template>
          </el-table-column>
          <el-table-column label="点击" prop="clickNumber" align="center" />
          <el-table-column label="发布日期" prop="publishDate" align="center" />
          <el-table-column label="下架时间" prop="updateDate" align="center">
            <template slot-scope="scope">
              <span v-show="scope.row.publishStatus===3">{{ scope.row.updateDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="publishStatus" align="center">
            <template slot-scope="scope">
              <span v-show="scope.row.publishStatus===1">未发布</span>
              <span v-show="scope.row.publishStatus===2">已上架</span>
              <span v-show="scope.row.publishStatus===3">已下架</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="260px">
            <template slot-scope="scope">
              <div v-if="scope.row.publishStatus===1">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="opAddOrEdit('edit',scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  @click="handlePublish('up',scope.row)"
                >
                  发布
                </el-button>
                <el-button
                  type="danger"
                  size="small"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </div>
              <div v-else>
                <el-button
                  type="primary"
                  size="small"
                  :disabled="true"
                >
                  上架
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  :disabled="scope.row.publishStatus===3"
                  @click="handlePublish('down',scope.row)"
                >
                  下架
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <!-- 新增编辑广告 -->
    <el-dialog
      v-if="hiddenVariable.dialogEditVisible"
      :before-close="closeDialogFn"
      :close-on-click-modal="false"
      :visible.sync="hiddenVariable.dialogEditVisible"
      :title="hiddenVariable.title"
      width="650px"
    >
      <dialog-info
        :type="hiddenVariable.type"
        :props-imgwh="hiddenVariable.imgwh"
        :data-list="hiddenVariable.text"
        @closeDialog="closeDialogFn"
      />
    </el-dialog>
  </div>
</template>

<script>

import DialogInfo from './dialogInfo';

// 获取API
import { getAdvertisingsBatch, deskadvertisingsPublish } from '@/api/productOperation/mrDesk/prosepoems';
export default {
  name: 'Advertisement',
  components: {
    DialogInfo
  },
  props: {
    tableData: {
      default: Array,
      type: Array
    },
    propsTable: {
      default: Object,
      type: Object
    }
  },
  data() {
    return {
      // 弹框标题
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false, // 学生详情
        type: 'add',
        id: '',
        title: '',
        text: {},
        imgwh: ''
      },
      // 搜索表单
      searchForm: {
      },
      dataList: [],
      listLoading: false // 表格刷新loading
    };
  },
  watch: {
    tableData: {
      handler(val) {
        if (val) {
          this.alldata = this.tableData;
          this.searchForm = {
            ...this.propsTable,
            ...this.searchForm
          };
        }
      },
      immediate: true
    }
  },

  mounted() {
    this.alldata = this.tableData;
    this.searchForm = {
      ...this.propsTable,
      ...this.searchForm
    };
  },
  methods: {

    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.$emit('getData', this.searchForm);
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.$emit('getData', this.searchForm);
    },

    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.ajaxLoading = false;
      if (type === 'add') {
        this.hiddenVariable.title = '新增';
      } else if (type === 'edit') {
        this.hiddenVariable.title = '编辑';
      } else {
        this.hiddenVariable.title = '发布';
      }
      this.hiddenVariable.type = type;
      if (type === 'add') {
        this.hiddenVariable.text = {
          locationId: this.searchForm.locationId,
          locationName: this.searchForm.locationName
        };
      } else {
        this.hiddenVariable.text = {
          locationId: this.searchForm.locationId,
          locationName: this.searchForm.locationName,
          ...row
        };
      }

      this.hiddenVariable.imgwh = this.searchForm.imgwh;

      this.hiddenVariable.dialogEditVisible = true;
    },
    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除该课桌广告么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            ids: [row.id],
            status: -1
          };
          return getAdvertisingsBatch(form);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.$emit('getData', this.searchForm);
        })
        .catch(() => { });
    },
    // 删除
    handlePublish(type, row) {
      var status = type === 'up' ? 2 : 3;
      var text = type === 'up' ? '发布' : '下架';
      this.$confirm(`确定要${text}该课桌广告么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = {
            ids: [row.id],
            status: status
          };
          return deskadvertisingsPublish(form);
        })
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: `${text}成功`,
            showClose: false,
            duration: 2000
          });
          this.$emit('getData', this.searchForm);
        })
        .catch(() => { });
    },
    // 弹框关闭
    closeDialogFn() {
      this.hiddenVariable = {
        dialogEditVisible: false, // 学生详情
        type: 'add',
        id: '',
        title: '',
        text: { locationId: this.searchForm.locationId,
          locationName: this.searchForm.locationName }
      };
      this.$emit('getData', this.searchForm);
    }
  }
};
</script>
<style lang="scss" scoped>
.advertisement {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 150px;
}
.handle-form-input {
  width: 80%;
}

.header-top {
  display: flex;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 30px;
  text-align: center;
  align-items: center;
  .tabs-panle {
    flex: 1;
    .tabs-wraper {
      height: 42px;
      line-height: 42px;
      text-align: center;
      display: inline-block;
      padding: 0 10px;
      span {
        padding: 0 30px;
        height: 42px;
        line-height: 42px;
        display: inline-block;
        border-top: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
      }
      .frist {
        border-radius: 20px 0 0 20px;
        border-left: 1px solid #e5e5e5;
      }
      .last {
        border-radius: 0 20px 20px 0;
        border-right: 1px solid #e5e5e5;
      }
      .active {
        background: #409eff;
        color: #fff;
      }
    }
  }
}
</style>
